export const SEARCH_VALUE_MIN_LENGTH = 3;

export const searchValueIsTooShort = (searchValue: string) =>
  searchValue.length < SEARCH_VALUE_MIN_LENGTH;
